import { t } from "@shared/utils/i18n";

/** 仓库服务商运营类型 */
export enum WarehouseOperationType {
    SelfBuilt = 1,
    ThirdParty = 2,
    LingxingErp = 3,
}

export const WAREHOUSE_OPERATION_TYPE_LABEL: Record<WarehouseOperationType, string> = {
    [WarehouseOperationType.SelfBuilt]: t("自建仓"),
    [WarehouseOperationType.ThirdParty]: t("第三方仓"),
    [WarehouseOperationType.LingxingErp]: t("自建-领星ERP"),
};

export const WAREHOUSE_SIDEBAR_GROUPS = [
    { key: "thirdParty", operationType: WarehouseOperationType.ThirdParty, title: t("三方仓") },
    { key: "selfBuilt", operationType: WarehouseOperationType.SelfBuilt, title: t("自定义") },
    { key: "lingxingErp", operationType: WarehouseOperationType.LingxingErp, title: t("三方ERP") },
] as const;

export const WAREHOUSE_STATUS_OPTIONS = [
    { label: t("启用"), value: 1 },
    { label: t("禁用"), value: 0 },
];

export const WAREHOUSE_LIST_SEARCH_OPTIONS = [
    { label: t("三方仓名称"), value: "whName", exact: false },
    { label: t("1P仓库名称"), value: "onePWhName", exact: false },
];

/** 海外仓 SKU Tab：UiCombinedSelect 字段选项（key 须与 combinedSearch / query 字段一致） */
export const WAREHOUSE_SKU_SEARCH_OPTIONS = [
    { label: t("海外仓SKU"), value: "warehouseSku", exact: false },
    { label: t("产品名称"), value: "productNameSnapshot", exact: false },
];

/** 物流渠道 Tab：UiCombinedSelect 字段选项（key 须与 combinedSearch / query 字段一致） */
export const WAREHOUSE_LOGISTICS_SEARCH_OPTIONS = [
    { label: t("物流渠道"), value: "channelName", exact: false },
    { label: t("渠道代码"), value: "carrierCode", exact: false },
];

export const WAREHOUSE_LIST_AUTH_TIP = t("授权成功后先同步三方仓库列表，再分别同步物流渠道和海外仓SKU");

/** 自定义仓：仓库列表工具条提示 */
export const WAREHOUSE_LIST_CUSTOM_TIP = t("自定义海外仓需要手动添加仓库");

/** WarehouseMatchStatusEnum（manage：已配对=2，未配对=1） */
export const WarehouseMatchStatus = {
    Unbound: 1,
    Bound: 2,
} as const;

export const WAREHOUSE_SKU_MAPPING_STATUS_OPTIONS = [
    { label: t("已配对"), value: WarehouseMatchStatus.Bound },
    { label: t("未配对"), value: WarehouseMatchStatus.Unbound },
];

export const WAREHOUSE_SKU_TYPE_LABEL: Record<number, string> = {
    1: t("未设置"),
    2: t("通用"),
    3: t("PO"),
    4: t("DF"),
};

/** 授权状态：0=未授权，1=已授权，2=授权失败 */
export const WAREHOUSE_AUTH_STATUS = {
    unauthorized: 0,
    authorized: 1,
    failed: 2,
} as const;

/** 同步状态：0=待同步，1=同步正常，2=同步异常 */
export const WAREHOUSE_SYNC_STATUS = {
    pending: 0,
    normal: 1,
    abnormal: 2,
} as const;

/** 仓库同步类异步任务类型（对应 /manage/asyncTask/batchDetail 的 taskType），与后端约定值保持一致 */
export const WAREHOUSE_ASYNC_TASK_TYPE = {
    ChannelSync: "WAREHOUSE_CHANNEL_SYNC",
    SkuSync: "WAREHOUSE_SKU_SYNC",
    InventorySync: "WAREHOUSE_INVENTORY_SYNC",
} as const;
